import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  materiales: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/materiales/index.js